import { useEffect, type ReactNode } from "react";
import {
  PageHeader,
  PageHeaderActions,
  PageHeaderDescription,
  PageHeaderHeading,
  PageHeaderTabs,
  PageHeaderTitle,
} from "@diametral/design-system/react";

export function useDocumentTitle(title: string) {
  useEffect(() => {
    document.title = title ? `${title} · ada` : "ada";
  }, [title]);
}

/** One screen: the DS page header (kicker, title, description, actions, tabs) over the content. */
export function Page({
  title,
  kicker,
  description,
  actions,
  breadcrumb,
  meta,
  tabs,
  children,
}: {
  title: ReactNode;
  kicker?: string;
  description?: ReactNode;
  actions?: ReactNode;
  breadcrumb?: ReactNode;
  /** A row under the title (status, TRL, technologies…). */
  meta?: ReactNode;
  tabs?: ReactNode;
  children: ReactNode;
}) {
  useDocumentTitle(typeof title === "string" ? title : "");
  return (
    <div className="ada-page">
      <PageHeader>
        {breadcrumb}
        <PageHeaderHeading>
          <div className="ada-stack ada-stack--tight">
            {kicker ? <p className="ds-kicker">{kicker}</p> : null}
            <PageHeaderTitle>{title}</PageHeaderTitle>
            {description ? <PageHeaderDescription>{description}</PageHeaderDescription> : null}
            {meta}
          </div>
          {actions ? <PageHeaderActions>{actions}</PageHeaderActions> : null}
        </PageHeaderHeading>
        {tabs ? <PageHeaderTabs>{tabs}</PageHeaderTabs> : null}
      </PageHeader>
      {children}
    </div>
  );
}
